import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useTimeoutFn } from '@vueuse/core'
import { useEprintSession } from '@/composables/format-edit/useEprintSession'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { buildEprintQrUrl } from '@/utils/format-edit/eprintQrUrl'


export default /*#__PURE__*/_defineComponent({
  __name: 'EprintQrCode',
  setup(__props) {

const session = useEprintSession()
const { varuna } = useHostServices()

const qrCodeImageSrc = computed(() =>
  buildEprintQrUrl({
    endpoint: varuna.endPoints.getEprintQrcode,
    contentsCode: session.eprintContentsCode,
    cacheBuster: session.qrCodeCacheBuster,
    isPrePayment: session.isPrePayment,
    selectedStore: session.selectedStore
  })
)

function forceReloadQRCode() {
  session.qrCodeCacheBuster = Date.now()
  session.isQRCodeLoaded = false
}

const retryTimer = useTimeoutFn(
  () => {
    forceReloadQRCode()
  },
  2000,
  { immediate: false }
)

function onQRCodeLoad() {
  session.isQRCodeLoaded = true
  session.qrCodeError = false
  session.qrCodeRetryCount = 0
}

function onQRCodeError() {
  session.qrCodeRetryCount++
  if (session.qrCodeRetryCount < 3) {
    retryTimer.start()
  } else {
    session.qrCodeError = true
    session.isQRCodeLoaded = true
  }
}

function retryQRCode() {
  session.qrCodeError = false
  session.isQRCodeLoaded = false
  session.qrCodeRetryCount = 0
  forceReloadQRCode()
}

return { __sfc: true,session, varuna, qrCodeImageSrc, forceReloadQRCode, retryTimer, onQRCodeLoad, onQRCodeError, retryQRCode }
}

})